import aviador from './aviador'
import hexagonal from './hexagonal'
import redondo from './redondo'
import sunglass from './sunglass'

export default {aviador, hexagonal, redondo, sunglass}